import i18n from "../i18nNext";

let Errors = {
    //PERMISSION
    NO_PERMISSION:
        "You don't have the privilege to see this.Please contact your admin to get the permission",
    INVALID_CONTENT: "You don't have the privilege to see this.",
    NO_EXPENSE_TYPE: "No expense type is configured.Please contact your admin",

    //AUTOLOAD
    AUTOLOAD_THRESHOLD_AMOUNT_MONEY_REQUEST_VALIDATION: "Please enter a threshold amount.",
    AUTOLOAD_LOAD_AMOUNT_MONEY_REQUEST_VALIDATION: "Please enter a load amount.",
    AUTOLOAD_THRESHOLD_AMOUNT_AUTO_LOAD_VALIDATION: "Please enter a threshold amount.",
    AUTOLOAD_LOAD_AMOUNT_AUTO_LOAD_VALIDATION: "Please enter a load amount.",
    //BALANCELIMIT
    COMPANY_BALANCE_VALIDATION: "Please enter the company balance.",
    VENDOR_BALANCE_VALIDATION: "Please enter the vendor balance.",
    PRIMARY_EMAIL_VALIDATION: "Please enter a primary email-id.",
    //CATEGORY
    CATEGORY_NAME: "Please provide a name to the category.",
    //ONBOARDING
    ONBOARDING_COUNTRY_CODE_MANDATORY: "Required",
    ONBOARDING_MOBILE_NO_MANDATORY: "Enter a valid mobile number.",
    ONBOARDING_MOBILE_NO_CORRECT: "Enter a valid mobile number.",
    ONBOARDING_EMAIL_MANDATORY: "Enter a valid mail id.",
    ONBOARDING_EMAIL_CORRECT: "Enter a valid mail id.",
    ONBOARDING_CARD_MANDATORY: "Select a card.",
    //ROle
    ROLE_NAME_MANDATORY: "Please enter a name for role.",
    //GROUP
    GROUP_NAME_MANDATORY: "Please enter a group name.",
    //ASSIGN_CARD
    ASSIGN_CARD_USER_CARD: "Please choose user and card.",
    //TRANSACTION_TYPE
    TRANSACTION_TYPE: "Please enter a type of transaction.",
    TRANSACTION_TYPE_STATUS: "Please select a status of transaction.",
    TRANSACTION_TYPE_IDENTIFIER: "Please enter an identifier.",
    TRANSACTION_TYPE_WALLET: "Please select a wallet of transaction",
    //REPORT_CONFIG
    SET_REPORT_CONFIG: "Please fill all the fields.",
    //TRAVEL_CONIG
    SET_TRAVEL_CONFIG: "Please fill all the fields.",
    //STATUS
    STATUS_NAME_MANDATORY: "Please enter a status name.",
    STATUS_TYPE_MANADATORY: "Please enter a status type.",
    //EXTRA_FIELD
    EXTRA_FIELD_NAME_MANDATORY: "Please provide a name.",
    EXTRA_FIELD_MAX_FILE_SIZE_MANDATORY: "Please provide an attachment number.",
    EXTRA_FIELD_DROPDOWN_VALUE_MANDATORY: "Please provide values for dropdown.",
    EXTRA_FIELD_NEW_FIELD_TYPE_MANDATORY: "Please add an override field.",
    EXTRA_FIELD_PRE_POST_FIX_STATE_MANDATORY: "Please provide the text.",
    //PASSWORD
    EXISTING_PASSWORD: "Please enter your existing password.",
    NEW_PASSWORD: "Please enter your new password.",
    CONFIRM_PASSWORD: "Please enter your confirm password.",
    NEW_CONFIRM_PASSWORD_MATCH: "Your confirm password should be same as new password.",
    VALID_OTP: "Enter a valid OTP",
    passwordCorrectFormat: "Please give password in correct format",
    //EXPENSES
    EXPENSES_SPENT_VALIDATION: "Enter a valid name.",
    EXPENSES_WALLET_VALIDATION: "Enter a valid wallet name.",
    EXPENSES_AMOUNT_VALIDATION: "Enter a valid amount.",
    NO_EXPRESSION: "Please create some expression first",
    EXPENSES_EXPRESSION_VALIDATION:
        "Cannot create this because there is no expression configured for this calculated type of expense",
    NO_BILL: "No bills attached",
    NO_CATEGORY: "Please enter category properly",
    NO_AMOUNT: "Please enter amount properly",
    NO_WALLET: "Please enter wallet properly",
    NO_CURRENCY: "Please enter currency properly",
    MAX_NO_OF_FILE: "Maximum number of files allowed to be attached at once is 5",
    MAX_FILE_SIZE: "Maximum allowed size for file upload at once is 15MB",
    addExistingTxn: "Please select atleast one expenses",
    MAX_NO_OF_BILLS: "A maximum of 25 bills can be uploaded for ScanX",
    //REPORTS
    REPORT_NAME_VALIDATION: "Enter a valid Name.",
    REPORT_DESCP_VALIDATION: "Enter a valid Description.",
    NO_SUCCESS_STATE_TRF: "No final state has been created for TRF",
    //TRAVEL
    TRAVEL_NAME_VALIDATION: "Enter a valid name.",
    TRAVEL_DESCP_VALIDATION: "Enter a valid Purpose of Travel.",
    //WORKFLOW
    WORKFLOW_MR_AMOUNT_VALIDATION: "Please give proper amount which needs to be approved",
    WORKFLOW_MR_REASON_VALIDATION: "Please give the reason for ",
    wfNotifyMonthDay: "Please select either individual day of month or last day of month",
    pDays: "Please give pending days",
    pFreq: "Please give pending frequency",
    pAcceptableAction: "Please select acceptable action",
    commonNotify: "Please select either pending days,frequency or month day",

    WORKFLOW_AUTO_AA_ERROR:
        "Only one action is allowed for each lineitem status when auto configuration is ON",
    WORKFLOW_CONTAINER_STATUS_MANDATORY: "Please select some container status for the setting",
    WORKFLOW_CONTAINER_LINEITEM_STATUS_MANDATORY:
        "Please select some container status and lineitem status for the setting",
    WORKFLOW_FORCE_EXIT_CONT_STATUS_MANDATORY: "Please select a valid Force Exit container status.",
    WORKFLOW_COMMENT_MANDATORY: "Please select one of the options in comments mandatory ",
    WORKFLOW_ALI_DUPLICATION_ERROR:
        "The allowed action mapping is already present for the selected status",
    WORKFLOW_ALI_ERROR: "Please provide the lineitem status",
    WORKFLOW_IAM_ERROR: "Please select something",
    WORKFLOW_IAM_DUPLICATION_ERROR:
        "The item action mapping is already present for the selected allowed action",
    WORKFLOW_ROLE_MANDATORY: "Please select a role",
    DELETE_ALI:
        "The mapping of the action is present in item action map.So please remove that first.",
    CREATE_STATE_SETTING:
        "There is no mapping of allowed actions in item action map for those defined in acceptable line item",
    ENTRY_STATE_REQUIRED: "Please select some entry states",
    EXIT_STATE_REQUIRED: "Please select some exit states",
    EXIT_STATE_CANNOT_BE_ENTRY_STATE: "Exit state(s) cannot be included in entry state",

    WORKFLOW_STATE_CONDITION_INVALID_EXPRESSION: "Please provide a valid logic",
    WORKFLOW_STATE_CONDITION_NO_EXPRESSION: "Please provide a logic before submitting",
    WORKFLOW_STATE_CONDITION_FROM_STATE: "Please provide a from state",
    WORKFLOW_STATE_CONDITION_TO_STATE: "Please provide a to state",

    //Logical Unit
    NO_OPERAND_TYPE: "Please provide any operand type",
    NO_OPERAND_VALUE: "Please provide any operand",
    NO_OPERATOR: "Please provide an operator",
    NO_ITEM_TYPE: "Please provide any item name",
    NO_AGGREGATOR: "Please provide an aggregator",

    //POLICY
    SELECT_CRITERIA: "Please select a criteria",
    SPECIFIC_AMOUNT: "Please enter specific amount",
    SELECT_WEEKDAY: "Please select week day",
    SELECT_MONTHDAY: "Please select month day",

    //Wallet configuration

    cardLoadText: "Please give template name",
    cardLoadDesc: "Please give description",
    wallet_action: "Please select wallet action",
    cardLoadAllEmp: "Please select either all employee or individually",
    allEmpWalletVal: "Please select list of employee individually",
    amount: "Please give amount",
    period: "Please select period",
    repeatEveryChangeVal: "Please select period value",
    repeatOnChangeTimeVal: "Please select time",
    repeatOnChangeVal: "Please select day of month",
    monthCheck: "Please select either last day of month or individual date",
    repeatOnChangeVal1: "Please select day of week",
    endsOnRadioVal: "Please select ends on",
    end_on_occurances: "Please give Occurences value",
    end_date: "Please give date",
    notifyRadioVal: "Please select either notify or auto load",
    notify_to: "Please select notify to",
    notifyActionVal: "Please select action",
    cut_off_amount: "Please give cut off amount",
    cut_off_amount_0: "Cut off amount should be greater than zero",
    floor_off_amount: "Please give floor limit amount",
    absoluteAmtval: "Please give absolute amount",
    absoluteAmtval_0: "Absolute amount should be greater than zero",
    roundOffVal: "Please give round off amount",
    roundOffVal_0: "Round off amount should be greater than zero",
    conditionDateVal: "Please select date of month",
    transferAmtToVal: "Please select transfer to",
    configWallet: "Please Select Organization Wallet .",
    configAmt: "Please enter a numeric value.",
    condition: "Please select a valid condition.",
    omcAmount: "Please fill the amount.",
    ccmsCategory: "Please choose limit interval.",
    dataNotFetched: "Omc Limit not fetched.",

    // WALLETS
    SELECT_WALLET: "Please Select Wallet",
    TRY_AGAIN: "Please try again",
    ENTER_PASSWORD: "Please enter password",
    INVALID_CITY: "Please select a valid city from the list.",
    INVALID_COUNTRY: "Please select a valid country from the list.",

    //login page
    LOGINVALIDATECODE: "Required",
    LOGINVALIDATION: "Mobile is required",
    LOGINVALIDATIONEMAIL: "Email id is required",
    LOGINVALIDATE: "Enter a Valid Email ID",
    LOGINEMAIL: "Enter a valid mobile no",
    LOGINPAGE: "Enter a Valid Email Id",
    PASSWORDVALIDATE: "Enter a valid password",

    //constant page
    CONSTANTNAMEVALIDATION: "Please Enter Name",
    CONSTANTVALUEVALIDATION: "Please Enter Value",

    //LDAP
    HOSTVALIDATION: "Please Enter Host Name",
    PORTVALIDATION: "Please Enter Port Name",
    ROOTVALIDATION: "Please Enter Root Directory",
    DOMAINVALIDATION: "Please Enter Sub Domain",

    //travelconfig
    HEADERVALIDATION: "Please enter a valid heading",
    FIELDVALIDATION: "Please enter a field name",
    ORDERVALIDATION: "Please enter a field order",
    INPUTVALIDATION: "Please select a input type",

    //addexpense
    EXPENSEAMOUNT: "Please Enter Amount",

    //Fill mandatory fields
    FILL_MANDATORY_FIELDS: "Kindly fill all the mandatory fields",

    //generatereport
    GENERATEREPORT: "kindly select a Report Name",
    VALIDID: "Kindly fill the valid mail ids",

    //settlement filter
    filterName: "Please provide a name to filter",
    filterDesc: "Please provide a description to the filter",
    filterValue: "Please provide a value to the filter",
    filterField: "Please select a field for filter",
    filterLineItem: "Please select a line item",
    filterOperator: "Please select operator for the filter",
    filterMultiOption: "Please select a field value",
    conditionOperator: "Please select a Math operator",
    conditionFilter: "Please select atleast one filter",
    conditionMethod: "Please select atleast one condition",
    reportCheck: "Please select a value for Report settlement",
    conditionDefault: "Please select if the method is default or not",
    conditionActiveStatus: "Please select a status for method",
    employeeVisible: "Please select a value for employee visibilty",
    conditionVisibility: "Please select a value for visibilty",
    conditionSelectedRole: "Please select a role types",
    settlementExcelHeaderField: "Please provide atleast one header field",
    settlementHeaderField: "Please select a header field",
    settlementExcelName: "Please provide a name of excel file",
    extraFieldValue: "Please select an extra field",
    selectSettleUser: "Please select atleast one user for settlement",
    settleBy: "Please select a value for Settle by",
    settleType: "Please select a settlement type",
    settleDate: "Please select a settlement date",
    settleMaxValidation:
        "Please enter lesser amount, total amount cannot be greater than company pool balance",
    methodName: "Please provide a name to method",
    conditionName: "Please provide a name to condition",
    defaultMethod: "Please select method for export",
    conditionAllOperator: "Please select the amount, date & operator",
    filterSelect: "Please select atleast one filter",
    containerVisible: "Please select the visibilty",
    amtBal: "Please give minimum or maximum amount for either opening/closing balance or amount",
    meth_filter: "Please select a method",

    /*Utility payment error msg*/
    COMPLAINT_TYPE: "Please select type of complain",
    TRANSACTION_ID: "Transaction Id is required",
    SERVICE_COMPLAIN_TYPE: "Please select complaint type",
    BILLER_ID: "Biller Id is required",
    DESCRIPTION_FIELD: "Description is required",
    REASON_VALIDATION: "Please select reason",
    SERVICE_REASON_VALIDATION: "Please select reason",
    PAY_BILL_MANDATORY_FIELDS: "Kindly fill all the mandatory fields",

    //city & country related

    //city & country related
    NO_CITY: "Please select at least one city",
    NO_CITY_ADMIN: "Please select city admin(s)",
    NO_COUNTRY: "Please enter a valid country",
    MESSAGEVALIDATION: "Please enter message field",
    MESSAGEEDITVALIDATION: "Please enter message field",

    bookTitle: "Please Select Title",
    bookFirst: "Please give First name",
    bookMob: "Please give Contact No",
    bookEmail: "Please give Email Id",
    travelDetail: "Please fill all the passenger details",
    bulkUserApprover: "Please select atleast one approver",
    FROM_DATE: "Please select from date",
    TO_DATE: "Please select to date",
    DELEGATION_USER: "Please select at least one user for delegation",

    //OMC
    vehicleNumber: "Please enter vehicle number",
    registrationYear: "Please enter registration year",
    manufacturer: "Please enter manufacturer",
    DRAFT_UPADTE:
        "Draft in update mode cannot be used to create new expense. Kindly use Happay Expense IOS/Android App for the same.",
    MAX_DOC_SIZE: "Maximum allowed size for file upload is 2MB",
    rcDoc: "Please upload RC DOC",
    chassisNumber: "Please enter the chassis number",
    rcNo: "Please enter the rc number",
    isCommercial: "please enter the commercial type",
    minThreshold: "please enter the min threshold",
    maxThreshold: "Please enter the max threshold",
    chassisNumberValidator: "Please enter the correct chassis number",
    rcNoValidator: "Plese enter correct rc number",
    adhocLimitBalance: "Please enter adhoc limit balance"
};

function init() {
    for (let key in Errors) {
        t(key);
    }
}

init();

function t(str, camleCase) {
    i18n.on("languageChanged", function(lng) {
        if (Errors) {
            Errors[str] = i18n.t(`err.${str}`);
        }
    });
}

module.exports = Errors;
